// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "daily-kos-beta." + "data_hub_web_analytics" + "." + "0f272cc290baffe250e2" + ".js";
};